import { jsx as _jsx } from "react/jsx-runtime";
import { Column } from '@dossierhq/design';
export function FieldDisplayListWrapper({ value, fieldSpec, Display, }) {
    if (!value)
        return null;
    return (_jsx(Column, { gap: 3, children: value.map((it, index) => {
            return (_jsx("div", { className: "nested-value-item-indentation", children: _jsx(Display, { value: it, fieldSpec: fieldSpec }) }, index));
        }) }));
}
//# sourceMappingURL=FieldDisplayListWrapper.js.map